import { authClient, restClient } from "ra-data-feathers"
import { Admin, Resource } from "react-admin"
import { eventProps } from "../../admin/events"
import { requestProps } from "../../admin/requests"
import api from "../../lib/api"

const restClientOptions = {
    id: '_id',
    usePatch: true
}
const authOptions = {
    storageKey: 'feathers-jwt',
    authenticate: {
        strategy: 'local',
    },
    passwordField: 'password',
    usernameField: 'email',
    logoutOnForbidden: true,
}

export default function AdminPage() {
    return (
        <Admin
            basename="/showroom/admin"
            dataProvider={restClient(api, restClientOptions)}
            authProvider={authClient(api, authOptions)}
            requireAuth={true}
        >
            <Resource {...eventProps} />
            <Resource {...requestProps} />
        </Admin>
    )
}